import React, { Dispatch, SetStateAction } from 'react';
import { AnalysisFilterState } from '../../../pages/AnalysisPage/Filter/analysisFilterState';
import VoxelSelect, { GenericSelectOption } from '../../voxel/Forms/VoxelSelect';
import { CurrentTeamGq } from '../../../graphql/users/models/CurrentTeamGq';

export interface SlideThemeSelectProps {
  analysisFilterState: AnalysisFilterState;
  setAnalysisFilterState: Dispatch<SetStateAction<AnalysisFilterState>>;
  disabled?: boolean;
  team?: CurrentTeamGq;
}

const SlideThemeSelect: React.FC<SlideThemeSelectProps> = ({
  analysisFilterState,
  setAnalysisFilterState,
  team,
}) => {
  const options = [{ title: 'Voxel theme', value: 'voxel' }];
  if (!!team.specialAnalysisTheme?.length) {
    options.push({
      title:
        team.specialAnalysisTheme.slice(0, 1).toUpperCase() +
        team.specialAnalysisTheme.slice(1) +
        ' theme',
      value: team.specialAnalysisTheme,
    });
  }
  return (
    <VoxelSelect
      options={options}
      setSelectedOption={(option) => {
        setAnalysisFilterState((prev) => ({ ...prev, theme: option.value }));
      }}
      selectedOptionValue={analysisFilterState?.theme ?? options[0].value}
      label="Slides and fonts"
      labelPosition="top"
    />
  );
};

export default SlideThemeSelect;
